/*
window.addEventListener("dx_init", function(){  
    dx_audios_init();
});
*/
if(window.parent==window){
    window.addEventListener("load", function(){
        dx_audios_init();
    });    
}  
window.addEventListener("dx_audio_init", function(event){ 
    dx_audio_init(event.detail.block);
});

function dx_audios_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-audio"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_audio_init(blocks[i]);               
    }   
}    

function dx_audio_init(block){
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");
    dx_audio_initControls(block, block.getElementsByTagName("audio")[0]);
    //dx_initControls(block, block.getElementsByTagName("audio")[0]);

}

function dx_audio_initControls(element, player){
    //same as in video
    let pane = element.getElementsByClassName("dx-controls-pane")[0];
    let playPause = element.getElementsByClassName("dx-controls-play-pause")[0];
    let time = element.getElementsByClassName("dx-controls-time")[0];
    let progress = element.getElementsByClassName("dx-controls-pane-progress")[0];
    pane.addEventListener("click", (event)=>{
        var rect = event.target.getBoundingClientRect();
        let pos = (event.clientX - rect.left) / rect.width;
        if(!isNaN(player.duration)){
            player.currentTime=pos*player.duration;
        }
    });
    playPause.addEventListener("click", ()=>{
        var play=element.getElementsByClassName('dx-controls-play')[0];
        var pause=element.getElementsByClassName('dx-controls-pause')[0];
        if(play.style.display=='inline-block'){
            player.play();
            play.style.display='none';
            pause.style.display='inline-block'; 
        } else {
            player.pause();
            play.style.display='inline-block';
            pause.style.display='none'; 
        } 
    });
    const displayDuration = ()=>{
        time.innerHTML = '0:00 / ' + dx_audio_convertSecondsToMinutes(player.duration);
    }
    if(isNaN(player.duration)){
        player.addEventListener("loadedmetadata", displayDuration);
    } else {
        displayDuration();
    }
    player.addEventListener("timeupdate", () => {
        progress.style.width=(player.currentTime/player.duration*100)+'%';
        time.innerHTML = dx_audio_convertSecondsToMinutes(player.currentTime) + ' / ' + dx_audio_convertSecondsToMinutes(player.duration);
    });
    player.addEventListener("click", () => {
        playPause.dispatchEvent(new Event("click"));
    });
}

function dx_audio_convertSecondsToMinutes(seconds) {
    let s = Math.floor(seconds)
    let minutes = Math.floor(s / 60);
    let extraSeconds = s % 60;
    if(extraSeconds < 10){
        extraSeconds = '0'+extraSeconds;
    }
    return minutes + ':' + extraSeconds;
}

  
